import { deleteReq, postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { AdvanceShare, AdvanceShareGenerateRequest, AdvanceSharePaginationFilterRequest } from '@/models/advance-share.model';
import { PagedResponseModel, BaseResponseModel } from "@/models/core.model";

export const getPagedAdvanceShares = async (input: AdvanceSharePaginationFilterRequest): Promise<PagedResponseModel<AdvanceShare>> => {
  return await getReq(createUrl("a/AdvanceShare/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getAdvanceShare = async (id: number): Promise<BaseResponseModel<AdvanceShare>> => {
  return await getReq(createUrl(`a/AdvanceShare/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const generateAdvanceShare = async (input: AdvanceShareGenerateRequest): Promise<BaseResponseModel<AdvanceShare>> => {
  return await postReq(createUrl("a/AdvanceShare/Generate"),
    input
  ).then((res: any) => res.data);
};


export const deleteAdvanceShare = async (id: number): Promise<BaseResponseModel<null>> => {
  return await deleteReq(createUrl(`a/AdvanceShare/Delete/${id}`),
  ).then((res: any) => res.data);
};
